/**
 * SEO component that queries for data with
 * Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import React from "react"
import { useStaticQuery, graphql } from "gatsby"

function Seo({
  description,
  title,
  image,
  children,
  canonical,
  type,
  modifiedTime
}) {

  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            favicon
          }
        }
      }
    `
  )



  const metaDescription = description || site.siteMetadata.description
  const favicon = site.siteMetadata.favicon
  console.log(title)

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={canonical} />
      <meta property="og:site_name" content="Napsis" />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:type" content="image/jpeg"/> 
      <meta property="og:url" content={canonical} />
      <meta property="article:modified_time" content={modifiedTime} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content={site.siteMetadata?.author || `Napsis`} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={metaDescription} />
      <link rel="icon" href={favicon} type="image/png"></link>
      {children}
    </>
  )
}

export default Seo
